import Repository from "./Repository";

class ComplementaryRepository extends Repository {

  async fetchCompSummaryByBatch(shopId, batchId) {
    const message = this.buildMessage({ shopId, batchId });
    try {
      const result = await this.apiPost({
        apiName: this.API_ADMIN_DASHBOARD,
        path: "/complementary/summary",
        message,
      });
      return result?.data?.summary || null;
    } catch (error) {
      console.warn("fetchCompSummaryByBatch error", error);
      return { error };
    }
  }

  async fetchCompAuditLog(shopId, batchId, limit = 200, lastKey = null) {
    const message = this.buildMessage({ shopId, batchId, limit, lastKey });
    try {
      const result = await this.apiPost({
        apiName: this.API_ADMIN_DASHBOARD,
        path: "/complementary/audit-log",
        message,
      });
      return result?.data?.items || [];
    } catch (error) {
      console.warn("fetchCompAuditLog error", error);
      return [];
    }
  }

  async fetchContacts(shopId, lastKey = null) {
    const message = this.buildMessage({ shopId, lastKey });
    try {
      const result = await this.apiPost({
        apiName: this.API_ADMIN_DASHBOARD,
        path: "/complementary/contacts",
        message,
      });
      return result?.data?.contacts || [];
    } catch (error) {
      console.warn("fetchContacts error", error);
      return [];
    }
  }

  async fetchCompTypes(shopId) {
    const message = this.buildMessage({ shopId });
    try {
      const result = await this.apiPost({
        apiName: this.API_ADMIN_DASHBOARD,
        path: "/complementary/types",
        message,
      });
      return result?.data?.types || [];
    } catch (error) {
      console.warn("fetchCompTypes error", error);
      return [];
    }
  }
}

export default ComplementaryRepository;
